// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IAddSubcategory, IAddArticle, IGetParentChildren, IEditCategory, IEditArticle, IEditArticlePayload } from "models/interfaces";

export const getAllCategories = createAsyncThunk(
  "support/category/get-all-categories",
  async (language: string, { rejectWithValue }) => {
    try {
      const response = await REST.get("/support/category/get-all-categories?language=" + language);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createCategory = createAsyncThunk(
  "support/category/create-category",
  async (title: string, { rejectWithValue }) => {
    try {
      const response = await REST.post("/support/category/create-category?categoryName=" + title);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "support/category/delete-category",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await REST.delete("/support/category/delete-category?categoryId=" + id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const editCategory = createAsyncThunk(
  "support/category/edit-category",
  async (data: IEditCategory, { rejectWithValue }) => {
    try {
      const response = await REST.put("support/category/edit-category?categoryId=" + data.id + "&language=" + data.language + "&newCategoryName=" + data.title);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getCategorySubcategories = createAsyncThunk(
  "support/category/get-category-subcategories",
  async (data: IGetParentChildren) => {
    try {
      const response = await REST.get("support/category/get-category-subcategories?categoryId=" + data.id + "&language=" + data.language);
      return response;
    } catch (err) {
      return err;
    }
  }
);

export const createSubcategory = createAsyncThunk(
  "support/subcategory/create-subcategory",
  async (data: IAddSubcategory, { rejectWithValue }) => {
    try {
      const response = await REST.post("/support/subcategory/create-subcategory?categoryId=" + data.id + "&subcategoryName=" + data.title);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteSubcategory = createAsyncThunk(
  "support/subcategory/delete-subcategory",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await REST.delete("/support/subcategory/delete-subcategory?subcategoryId=" + id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const editSubcategory = createAsyncThunk(
  "support/subcategory/edit-subcategory",
  async (data: IEditCategory, { rejectWithValue }) => {
    try {
      const response = await REST.put("/support/subcategory/edit-subcategory?language=" + data.language + "&newSubcategoryName=" + data.title + "&subcategoryId=" + data.id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getSubcategoryArticles = createAsyncThunk(
  "support/article/get-subcategory-articles",
  async (data: IGetParentChildren) => {
    try {
      const response = await REST.get("/support/article/get-subcategory-articles?language=" + data.language + "&subcategoryId=" + data.id);
      return response;
    } catch (err) {
      return err;
    }
  }
);

export const createArticle = createAsyncThunk(
  "support/article/create-article",
  async (data: IAddArticle, { rejectWithValue }) => {
    try {
      const response = await REST.post("/support/article/create-article?=", data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteArticle = createAsyncThunk(
  "support/article/delete-article",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await REST.delete("/support/article/delete-article?articleId=" + id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const editArticle = createAsyncThunk(
  "support/article/edit-article",
  async (payload: IEditArticlePayload, { rejectWithValue }) => {
    try {
      const response = await REST.put(`/support/article/edit-article?language=${payload.language}`, payload.data);
      return response.data;
    } catch (err) {
      console.log(err)
      return rejectWithValue(err);
    }
  }
);